/* Cichobud v7: wybór koloru i ilości, pasek zakupu, animacje przy przewijaniu, suwak przed i po, karuzela. Bez bibliotek. */
(function () {
  if (window.__cichobud7) return; window.__cichobud7 = true;
  var doc = document;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var hasIO = 'IntersectionObserver' in window;
  doc.documentElement.classList.add('cb-js');

  function money(c) {
    var z = Math.floor(c / 100), g = c % 100;
    var t = String(z).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    return t + (g ? ',' + (g < 10 ? '0' + g : g) : '') + '\u00a0z\u0142';
  }
  function qtyOf(root) {
    var i = root.querySelector('[data-cb-qtyinput]');
    var n = i ? parseInt(i.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  function setText(root, sel, txt) {
    root.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; });
  }
  function apply(root) {
    var input = root.querySelector('input[data-cb-variant]:checked');
    if (!input) return;
    var d = input.dataset;
    var n = qtyOf(root);
    var cents = parseInt(d.cents, 10) || 0;
    setText(root, '[data-cb-price]', d.price);
    setText(root, '[data-cb-color-name]', d.qty);
    setText(root, '[data-cb-qty]', d.qty + (n > 1 ? ' \u00d7 ' + n : ''));
    setText(root, '[data-cb-qtyout]', n);
    if (cents) setText(root, '[data-cb-total-btn]', money(cents * n));
    root.querySelectorAll('[data-cb-ship]').forEach(function (el) {
      var thr = parseInt(el.getAttribute('data-thr'), 10) || 0;
      var t = el.querySelector('[data-cb-ship-t]') || el;
      if (thr && cents) t.textContent = (cents * n >= thr) ? el.getAttribute('data-free') : el.getAttribute('data-paid');
    });
    var img = root.querySelector('[data-cb-img]');
    if (img && d.img && img.getAttribute('src') !== d.img) {
      var swap = function () {
        img.setAttribute('src', d.img);
        if (d.srcset) img.setAttribute('srcset', d.srcset); else img.removeAttribute('srcset');
        img.classList.remove('is-swap');
      };
      if (reduce) { swap(); } else { img.classList.add('is-swap'); window.setTimeout(swap, 180); }
    }
    var st = root.querySelector('[data-cb-sthumb]');
    if (st && d.thumb) st.setAttribute('src', d.thumb);
  }
  function setQty(root, n) {
    n = Math.max(1, Math.min(10, n));
    var i = root.querySelector('[data-cb-qtyinput]'); if (i) i.value = n;
    apply(root);
  }
  doc.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-cb-minus],[data-cb-plus]');
    if (!t) return;
    var root = t.closest('[data-cb-buy]'); if (!root) return;
    setQty(root, qtyOf(root) + (t.hasAttribute('data-cb-plus') ? 1 : -1));
  });
  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[data-cb-variant]')) {
      var root = t.closest('[data-cb-buy]'); if (root) apply(root);
    }
  });

  /* pasek zakupu na dole (telefon) */
  var stickyState = { heroOut: false, finalIn: false, bar: null };
  function updateSticky() {
    var bar = stickyState.bar; if (!bar) return;
    var on = stickyState.heroOut && !stickyState.finalIn;
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    var b = bar.querySelector('button'); if (b) b.setAttribute('tabindex', on ? '0' : '-1');
  }
  var sio = null;
  function initSticky() {
    var bar = doc.querySelector('[data-cb-sticky]');
    stickyState.bar = bar;
    if (!bar || !hasIO) return;
    if (sio) sio.disconnect();
    sio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.target.hasAttribute('data-cb-buyanchor')) {
          stickyState.heroOut = !e.isIntersecting && e.boundingClientRect.bottom < 0;
        } else {
          stickyState.finalIn = e.isIntersecting;
        }
      });
      updateSticky();
    }, { threshold: 0 });
    var a = doc.querySelector('[data-cb-buyanchor]'); if (a) sio.observe(a);
    var f = doc.querySelector('[data-cb-final]'); if (f) sio.observe(f);
  }

  /* pojawianie się elementów */
  var rio = null;
  function initReveal() {
    var els = doc.querySelectorAll('.cb-reveal:not(.cb-in)');
    var design = !!(window.Shopify && window.Shopify.designMode);
    if (!hasIO || reduce || design) { els.forEach(function (el) { el.classList.add('cb-in'); }); return; }
    if (!rio) {
      rio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('cb-in'); rio.unobserve(e.target); if (e.target.hasAttribute('data-cb-ba')) baIntro(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { rio.observe(el); });
    window.setTimeout(function () { doc.querySelectorAll('.cb-reveal:not(.cb-in)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight * 1.2) el.classList.add('cb-in'); }); }, 2500);
  }

  /* przed i po */
  function baIntro(ba) {
    if (reduce || ba.__intro) return; ba.__intro = true;
    var t0 = null, from = 90, to = 50;
    function step(ts) {
      if (ba.__touched) return;
      if (!t0) t0 = ts;
      var k = Math.min(1, (ts - t0) / 1100);
      var e = 1 - Math.pow(1 - k, 3);
      setBa(ba, from + (to - from) * e);
      if (k < 1) window.requestAnimationFrame(step);
    }
    setBa(ba, from);
    window.requestAnimationFrame(step);
  }
  function setBa(ba, v) {
    ba.style.setProperty('--p', v + '%');
    var r = ba.querySelector('[data-cb-ba-range]'); if (r) r.value = Math.round(v);
  }
  function initBa() {
    doc.querySelectorAll('[data-cb-ba]').forEach(function (ba) {
      if (ba.__init) return; ba.__init = true;
      var r = ba.querySelector('[data-cb-ba-range]'); if (!r) return;
      var on = function () { ba.__touched = true; ba.style.setProperty('--p', r.value + '%'); };
      r.addEventListener('input', on);
      r.addEventListener('pointerdown', function () { ba.__touched = true; });
    });
  }

  /* karuzela kroków: kropki */
  function initCarousels() {
    doc.querySelectorAll('[data-cb-carousel]').forEach(function (c) {
      if (c.__init) return; c.__init = true;
      var dots = c.parentNode.querySelectorAll('.cb-dots span');
      if (!dots.length) return;
      var raf = 0;
      c.addEventListener('scroll', function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = 0;
          var kids = c.children, mid = c.scrollLeft + c.clientWidth / 2, best = 0, bd = 1e9;
          for (var i = 0; i < kids.length; i++) {
            var m = kids[i].offsetLeft + kids[i].offsetWidth / 2, dd = Math.abs(m - mid);
            if (dd < bd) { bd = dd; best = i; }
          }
          dots.forEach(function (d, i) { d.classList.toggle('is-on', i === best); });
        });
      }, { passive: true });
    });
  }

  /* licznik koszyka w nagłówku: odświeżany po każdej zmianie koszyka (dodanie, zmiana ilości, usunięcie) */
  function setCount(n) {
    var a = doc.querySelector('.cb-head__cart'); if (!a) return;
    var c = a.querySelector('.cb-head__count');
    if (n > 0) {
      if (!c) { c = doc.createElement('span'); c.className = 'cb-head__count'; a.appendChild(c); }
      c.textContent = n;
    } else if (c) { c.remove(); }
    a.setAttribute('aria-label', 'Koszyk, liczba produktów: ' + n);
  }
  function syncCount() {
    var f = window.__cbFetch || window.fetch;
    f('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && typeof c.item_count === 'number') setCount(c.item_count); })
      .catch(function () {});
  }
  if (!window.__cbFetch && window.fetch) {
    window.__cbFetch = window.fetch;
    window.fetch = function () {
      var a = arguments, u = '';
      try { u = String(a[0] && a[0].url ? a[0].url : a[0]); } catch (e) {}
      var p = window.__cbFetch.apply(this, a);
      if (/\/cart\/(add|change|update|clear)/.test(u)) { p.then(function () { setTimeout(syncCount, 150); }).catch(function () {}); }
      return p;
    };
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncCount(); });

  /* menu mobilne: hamburger, panel z linkami; zamykanie linkiem, Esc, X i tłem */
  var menuLast = null;
  function menuOpen(m, btn) {
    if (!m || !m.hidden) return;
    menuLast = btn || null;
    m.hidden = false;
    doc.documentElement.style.overflow = 'hidden';
    if (btn) btn.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { requestAnimationFrame(function () { m.classList.add('is-open'); }); });
    var x = m.querySelector('.cb-menu__x'); if (x) setTimeout(function () { x.focus(); }, reduce ? 0 : 60);
  }
  function menuClose(m, noFocus) {
    if (!m || m.hidden) return;
    m.classList.remove('is-open');
    doc.documentElement.style.overflow = '';
    doc.querySelectorAll('[data-cb-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var done = function () { if (!m.classList.contains('is-open')) m.hidden = true; };
    if (reduce) done(); else setTimeout(done, 320);
    if (!noFocus && menuLast) menuLast.focus();
  }
  if (!doc.__cbMenu) {
    doc.__cbMenu = true;
    doc.addEventListener('click', function (e) {
      var t = e.target;
      var ob = t.closest && t.closest('[data-cb-menu-open]');
      if (ob) { e.preventDefault(); menuOpen(doc.getElementById(ob.getAttribute('aria-controls')), ob); return; }
      var m = t.closest && t.closest('[data-cb-menu]');
      if (!m) return;
      if (t.closest('[data-cb-menu-close]')) { menuClose(m); return; }
      if (t.closest('a')) menuClose(m, true);
    });
    doc.addEventListener('keydown', function (e) {
      var m = doc.querySelector('[data-cb-menu]:not([hidden])'); if (!m) return;
      if (e.key === 'Escape' || e.key === 'Esc') { menuClose(m); return; }
      if (e.key === 'Tab') {
        var f = m.querySelectorAll('a[href],button'); if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && doc.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && doc.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990) { var m = doc.querySelector('[data-cb-menu]:not([hidden])'); if (m) menuClose(m, true); }
    });
  }

  /* nagłówek: cień po przewinięciu (na komputerze przewija się .page-wrapper) */
  function initHead() {
    var h = doc.querySelector('[data-cb-head]'); if (!h) return;
    var wrap = doc.querySelector('.page-wrapper');
    var f = function () {
      var y = Math.max(window.pageYOffset || 0, wrap ? wrap.scrollTop : 0);
      h.classList.toggle('is-scrolled', y > 8);
    };
    if (!doc.__cbHead) {
      doc.__cbHead = true;
      doc.addEventListener('scroll', function () { var hh = doc.querySelector('[data-cb-head]'); if (hh) { var w = doc.querySelector('.page-wrapper'); var y = Math.max(window.pageYOffset || 0, w ? w.scrollTop : 0); hh.classList.toggle('is-scrolled', y > 8); } }, { passive: true, capture: true });
    }
    f();
  }

  /* wideo MP4 ładowane dopiero przy zbliżeniu do ekranu */
  function loadVid(v) {
    if (v.dataset.loaded) return; v.dataset.loaded = '1';
    v.src = v.dataset.src;
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  var vio = hasIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { loadVid(v); if (!reduce && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
      else if (v.dataset.loaded && !v.paused) { v.pause(); }
    });
  }, { rootMargin: '300px 0px' }) : null;
  function initVids() {
    doc.querySelectorAll('video[data-cb-lazyvid]').forEach(function (v) {
      if (v.dataset.obs) return; v.dataset.obs = '1';
      if (vio) vio.observe(v); else loadVid(v);
    });
  }

  /* ustawienia cookies (tylko gdy Shopify udostępnia okno zgody) */
  function initCookies() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    doc.querySelectorAll('[data-cb-cookies]').forEach(function (b) {
      if (b.__init) return; b.__init = true;
      var can = cp && typeof cp.showPreferences === 'function';
      if (can) b.hidden = false;
      b.addEventListener('click', function () {
        var c = window.Shopify && window.Shopify.customerPrivacy;
        if (c && typeof c.showPreferences === 'function') c.showPreferences();
      });
    });
  }

  function init() {
    doc.querySelectorAll('[data-cb-buy]').forEach(apply);
    initSticky(); initReveal(); initBa(); initCarousels(); initHead(); initVids(); initCookies();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', initCookies);
  doc.addEventListener('shopify:section:load', init);
})();
